import { CommissionPayment } from "../my-type";
import { authUserData } from ".";
import {
  callApi,
  configureApiClient,
  fetchWithApiClient,
} from "../api/client";
import { CommissionPaymentService as GeneratedCommissionPaymentService } from "../generated/api/services/CommissionPaymentService";
import type { UpdateCommissionPaymentRequest } from "../generated/api/models/UpdateCommissionPaymentRequest";

type UploadTransferReceiptImgResponse = {
  message: string;
  fileName: string;
};

const configureCommissionPaymentApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

const normalizeCommissionPayment = (item: any): CommissionPayment => ({
  ...item,
});

export const getCommissionPayments = async (
  status?: string | null,
  teamCode?: string | null
): Promise<CommissionPayment[] | null> => {
  try {
    configureCommissionPaymentApiClient();
    const data = await callApi(
      () =>
        GeneratedCommissionPaymentService.getApiCommissionPaymentGetAll(
          status ?? undefined,
          teamCode ?? undefined
        ),
      "取得佣金付款資料失敗"
    );

    return (data as any[]).map(normalizeCommissionPayment);
  } catch (error) {
    console.error("Error fetching commission payments:", error);
    return null;
  }
};

export const getCommissionPaymentByOrderID = async (
  orderID: string
): Promise<CommissionPayment | null> => {
  try {
    configureCommissionPaymentApiClient();
    const data = await callApi(
      () => GeneratedCommissionPaymentService.getApiCommissionPaymentGetByOrderId(orderID),
      "取得佣金付款資料失敗"
    );

    return normalizeCommissionPayment(data);
  } catch (error) {
    console.error("Error fetching commission payment:", error);
    return null;
  }
};

export const updateCommissionPayment = async (
  orderID: string,
  request: UpdateCommissionPaymentRequest
): Promise<CommissionPayment> => {
  configureCommissionPaymentApiClient();
  const data = await callApi(
    () =>
      GeneratedCommissionPaymentService.putApiCommissionPaymentUpdateStatusAndPaymentReference(
        orderID,
        request
      ),
    "更新佣金付款資料失敗"
  );

  return normalizeCommissionPayment(data);
};

export const uploadCommissionPaymentReceipt = async (
  orderID: string,
  receipt: File
): Promise<UploadTransferReceiptImgResponse> => {
  if (!receipt || !(receipt instanceof File)) {
    throw new Error("Invalid receipt file provided.");
  }

  configureCommissionPaymentApiClient();
  const data = await callApi(
    () =>
      GeneratedCommissionPaymentService.postApiCommissionPaymentUploadTransferReceiptImg(
        orderID,
        {
          Receipt: receipt,
        }
      ),
    "上傳轉帳證明失敗"
  );

  return data as UploadTransferReceiptImgResponse;
};

export const getCommissionPaymentReceiptImage = async (
  orderID: string
): Promise<string | null> => {
  try {
    configureCommissionPaymentApiClient();
    const response = await fetchWithApiClient(
      `/api/CommissionPayment/${encodeURIComponent(orderID)}/GetTransferReceiptImg`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      if (response.status !== 404) {
        console.error("Error fetching commission payment receipt:", response.status);
      }
      return null;
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching commission payment receipt:", error);
    return null;
  }
};
